import { render, staticRenderFns } from "./main-card-center.vue?vue&type=template&id=f2933ed4&"
import script from "./main-card-center.vue?vue&type=script&lang=js&"
export * from "./main-card-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "main-card-center.vue"
export default component.exports